import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex, useToast } from '@chakra-ui/react'
import { MdUnpublished } from "react-icons/md";
import { resetUpdatePdsrOutcome, updatePdsr } from '../../actions/dsr-actions'
import { redirectToNewPage, triggerLaunchdeckToast } from '../../../global/helpers/global-helpers'
import PageLoader from '../../../global/components/helper-components/components/PageLoader'
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton'
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal'



function ProspectDsrUnpublishModal({
  pDsrId,
  handleCloseModal,
  updateProspectDsrOutcome,
  updatePdsr,
  resetUpdatePdsrOutcome,
  isMobileView
}) {

  const toast = useToast();

  // UX Management
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {

    if (updateProspectDsrOutcome) {
      const { updatePdsrStatus, sourceEvent } = updateProspectDsrOutcome || {};

      if (updatePdsrStatus && sourceEvent === "unpublish-prospector-dsr") {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-success-state",
            bannerText: "Prospector room unpublished",
            label: "The Prospector Room is now back in draft state",
            isMobileView
          })
        )

        resetUpdatePdsrOutcome()
        redirectToNewPage(`/draft/pdsr/${pDsrId}`)
      }
    }

  }, [updateProspectDsrOutcome, pDsrId, resetUpdatePdsrOutcome, toast]);

  const handleClickUnpublishButton = () => {
    setShowLoader(true);
    updatePdsr({
      pDsrId,
      sourceEvent: "unpublish-prospector-dsr",
      status: 'reverted-draft'
    })
  }

  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {

      return (
        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
            Guest & Host Members will not be able to view it when unpublished. Proceed?
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brandPink.500' w={['100%', 'auto']} color='white' fontSize='0.8em' py='0.4em' onClick={() => handleClickUnpublishButton()} label='Unpublish' />
          </Flex>
        </Box>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={MdUnpublished} color='brandPink.500' boxSize="1.6em" />
        <Box color='white'>Unpublish this Prospector</Box>
      </Flex>}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    updateProspectDsrOutcome: state.updateProspectDsrOutcome.results.data,
    isMobileView: state.mobileViewMode.isMobileView
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updatePdsr,
      resetUpdatePdsrOutcome
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProspectDsrUnpublishModal));
